// Testing frameworks showcase section
import React, { useState } from "react";
import styled from "styled-components";
import TestCard from "./TestCard";
import ProjectData from "../Projects/projectData";
import { useLanguage } from "../../contexts/LanguageContext";
import { getTranslation } from "../../translations/translations";
import CertificateModal from "./CertificateModal";
import playwrightCertificate from "../../images/playwrite_automation.png";

function Tests() {
  const { language } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Filter projects that have category "tests"
  const testProjects = ProjectData.filter(
    (project) => project.category === "tests"
  );

  return (
    <Wrap>
      <ItemText>
        <h1>{getTranslation(language, "tests.title") || "Tests"}</h1>
      </ItemText>

      <CertificateSection>
        <CertificateLabel>
          {getTranslation(language, "tests.certificate") || "Certifications"}
        </CertificateLabel>
        <CertificatePreview onClick={() => setIsModalOpen(true)}>
          <CertificateThumbnail
            src={playwrightCertificate}
            alt="Playwright Automation Certificate"
          />
          <CertificateOverlay>
            <ViewText>
              {getTranslation(language, "tests.viewCertificate") || "View Certificate"}
            </ViewText>
          </CertificateOverlay>
        </CertificatePreview>
      </CertificateSection>

      {testProjects.length > 0 ? (
        <CardsContainer>
          <Cards>
            {testProjects.map((project, index) => (
              <TestCard
                key={index}
                {...project}
                translationKey={project.translationKey}
              />
            ))}
          </Cards>
        </CardsContainer>
      ) : (
        <NoResults>
          {getTranslation(language, "tests.noResults") ||
            "No test projects found."}
        </NoResults>
      )}

      <CertificateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        imageSrc={playwrightCertificate}
        altText="Playwright Automation Certificate"
      />
    </Wrap>
  );
}

export default Tests;

const Wrap = styled.div`
  min-height: 100vh;
  background-color: rgba(248, 241, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 490px) {
    overflow-x: hidden;
  }
`;

const ItemText = styled.div`
  margin-top: 90px;
  color: black;

  h1 {
    @media (max-width: 768px) {
      font-size: 24px;
      margin-top: -4px;
    }
  }
`;

const CardsContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  padding: 0 20px;
`;

const Cards = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 25px;
  width: 100%;

  @media (max-width: 968px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  @media (max-width: 480px) {
    gap: 15px;
  }
`;

const NoResults = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 1.1rem;

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 30px 15px;
  }
`;

const CertificateSection = styled.div`
  width: 100%;
  max-width: 1400px;
  padding: 0 20px;
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    margin: 20px 0;
    padding: 0 15px;
  }
`;

const CertificateLabel = styled.h2`
  font-size: 1.2rem;
  text-transform: uppercase;
  color: black;
  margin-bottom: 15px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 12px;
  }
`;

const CertificatePreview = styled.div`
  position: relative;
  cursor: pointer;
  border: 2px solid rgba(83, 83, 83, 0.3);
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  max-width: 180px;
  width: 100%;

  &:hover {
    border-color: rgba(83, 83, 83, 0.6);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    max-width: 150px;
  }

  @media (max-width: 480px) {
    max-width: 120px;
  }
`;

const CertificateThumbnail = styled.img`
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
  object-fit: cover;

  ${CertificatePreview}:hover & {
    transform: scale(1.05);
  }
`;

const CertificateOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${CertificatePreview}:hover & {
    opacity: 1;
  }
`;

const ViewText = styled.span`
  color: white;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;
